import styled from 'vue-styled-components';

import { FLEX_VERTICAL_CENTER_DIV } from '@styles/common.styled.component';

export const Wrapper = styled(FLEX_VERTICAL_CENTER_DIV)`
    gap: 8px;
`;

export const Button = styled(FLEX_VERTICAL_CENTER_DIV)`
    flex: 1;
    height: 64px;
    padding: 10px 12px;
    gap: 8px;
    border-radius: 10px;
    border: 1px solid #e2e7eb;
    background: #ffffff;
    cursor: pointer;
    transition: opacity 0.2s;

    &:hover {
        background: #f4f6f8;
    }
`;

export const ButtonTitle = styled.div`
    font-size: 13px;
    font-weight: 500;
    color: #000000;
`;

export const ButtonDesc = styled(FLEX_VERTICAL_CENTER_DIV)`
    font-size: 12px;
    font-weight: 400;
    color: #1557d9;

    svg {
        width: 16px;
        height: 16px;

        &,
        &* {
            fill: #1557d9;
        }
    }
`;
